import React, {createRef} from 'react';
import {getServerTexts} from '../texts';
import {PersonalizationCenter} from './PersonalizationCenter';

export const personalizationCenterRef: React.RefObject<{reloadData: () => void}> = createRef();

export async function renderPersonalizationCenter(root) {
    await getServerTexts();
    root.render(<PersonalizationCenter ref={personalizationCenterRef} />);
    return personalizationCenterRef;
}
